import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[skyproCommunicationLike]',
  standalone: true,
})
export class CommunicationLikeDirective {
  readonly templateRef = inject(TemplateRef<unknown>);
}
